import { useMutation, UseMutationOptions } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { entityExportsApi } from 'src/Services/API';
import {
  CreateEntityExportDtoEntityTypeEnum,
  CreateEntityExportDtoRuleEnum,
  CreateEntityExportDtoTypeEnum,
  EntityExportDto,
} from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';
import { ApiError } from 'src/types/api-error.types';

export const useCreatePlanningExport = (
  options?: UseMutationOptions<EntityExportDto, ApiError, void>
) => {
  const assetId = useCurrentAssetId();

  return useMutation<EntityExportDto, ApiError, void>(
    ['create-planning-export', assetId],
    async () => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      const dto = {
        entityType: CreateEntityExportDtoEntityTypeEnum.Event,
        type: CreateEntityExportDtoTypeEnum.Dynamic,
        rule: CreateEntityExportDtoRuleEnum.All,
        isPublic: true,
      };

      const response = await entityExportsApi.entityExportsControllerCreate(assetId, dto);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        trackEvent('Export', 'create', 'plannings');
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
